export const MODULE_NAME = 'amex-connect-root';
